<template>
  <div class="access-denied-container">
    <div class="access-denied-card">
      <div class="icon">🔒</div>
      <h1>{{ t("Access Denied") }}</h1>
      <p>{{ t("You need to be logged in to access this page") }}</p>
      <p>{{ t("Please return to the main site and log in first") }}</p>
      <a :href="isavtaUrl" class="btn-primary">
        {{ t("Go to iSavta") }}
      </a>
    </div>
  </div>
</template>
<script setup>
import { getStorage } from '@/services/storage';
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex';
const store = useStore();
const savedLocale = getStorage('locale')
const browserLocale = navigator.language.startsWith('he') ? 'he' : 'en'
const lang  = store.getters.locale || savedLocale || browserLocale;
const isavtaUrl  =  (process.env.VUE_APP_ISAVTA_URL || 'https://misgav.isavta.co.il') + '/' + lang+'/salary/welcome';

const { t } = useI18n();
</script>

<style scoped>
.access-denied-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  font-family: Arial, sans-serif;
}

.access-denied-card {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  text-align: center;
  max-width: 400px;
}

.icon {
  font-size: 64px;
  margin-bottom: 20px;
}

h1 {
  color: #dc2626;
  margin-bottom: 16px;
}

p {
  color: #6b7280;
  margin-bottom: 24px;
  line-height: 1.5;
}

.btn-primary {
  display: inline-block;
  background-color: #2563eb;
  color: white;
  padding: 12px 28px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  transition: background 0.2s;
}

.btn-primary:hover {
  background-color: #1d4ed8;
}
</style>